<template>
  <div class="love-pk-theme-list">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>PK主题管理</span>
          <el-button type="primary" @click="handleAdd">添加主题</el-button>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="主题">
          <el-input v-model="searchForm.theme" placeholder="请输入PK主题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="themeList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="theme" label="PK主题" min-width="220"></el-table-column>
        <el-table-column prop="believe_name" label="相信阵营" width="120">
          <template #default="scope">
            <el-tag type="primary" size="small">{{ scope.row.believe_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="disbelieve_name" label="不相信阵营" width="120">
          <template #default="scope">
            <el-tag type="danger" size="small">{{ scope.row.disbelieve_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="background_image" label="背景图" width="100">
          <template #default="scope">
            <el-image
              v-if="scope.row.background_image"
              :src="scope.row.background_image"
              class="bg-thumb"
              fit="cover"
              :preview-src-list="[scope.row.background_image]"
            ></el-image>
            <span v-else class="bg-thumb--empty">默认</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-switch
              :value="scope.row.status === 1"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template #default="scope">
            <el-button size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>

    <!-- 添加/编辑主题对话框 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="520px" @close="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="110px">
        <el-form-item label="AI生成">
          <div class="ai-generate">
            <el-button
              type="success"
              icon="el-icon-magic-stick"
              :loading="aiGenerating"
              @click="handleAiGenerate"
            >
              {{ aiGenerating ? 'AI生成中...' : 'AI一键生成主题' }}
            </el-button>
            <div class="ai-generate__tip">由DeepSeek生成，填充后可再手动修改</div>
          </div>
        </el-form-item>
        <el-form-item label="PK主题" prop="theme">
          <el-input v-model="form.theme" placeholder="请输入PK主题，如：你还相信爱情么？" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="相信阵营" prop="believe_name">
          <el-input v-model="form.believe_name" placeholder="如：相信" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="不相信阵营" prop="disbelieve_name">
          <el-input v-model="form.disbelieve_name" placeholder="如：不相信" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="背景图">
          <el-upload
            class="bg-uploader"
            action="/api/admin/upload/image"
            :headers="uploadHeaders"
            :data="{ dir: 'love-pk-theme' }"
            name="file"
            accept="image/jpeg,image/png,image/gif"
            :show-file-list="false"
            :before-upload="beforeBgUpload"
            :on-success="handleBgSuccess"
            :on-error="handleBgError"
          >
            <img v-if="form.background_image" :src="form.background_image" class="bg-uploader__preview">
            <div v-else class="bg-uploader__placeholder" v-loading="bgUploading">
              <i class="el-icon-plus"></i>
              <span>上传背景图</span>
            </div>
          </el-upload>
          <el-button
            v-if="form.background_image"
            type="text"
            class="bg-uploader__remove"
            @click="form.background_image = ''"
          >移除</el-button>
          <div class="bg-uploader__tip">JPG/PNG/GIF，不超过5MB；不上传则使用默认背景</div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999" controls-position="right"></el-input-number>
          <span class="form-tip">数值越小越靠前</span>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            :value="form.status === 1"
            @change="(val) => form.status = val ? 1 : 0"
          ></el-switch>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'LovePkThemeList',
  data() {
    return {
      themeList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: { theme: '' },
      dialogVisible: false,
      dialogTitle: '添加主题',
      submitting: false,
      aiGenerating: false,
      bgUploading: false,
      form: {
        id: null,
        theme: '',
        believe_name: '',
        disbelieve_name: '',
        background_image: '',
        status: 1,
        sort: 0
      },
      formRules: {
        theme: [{ required: true, message: '请输入PK主题', trigger: 'blur' }],
        believe_name: [{ required: true, message: '请输入相信阵营名字', trigger: 'blur' }],
        disbelieve_name: [{ required: true, message: '请输入不相信阵营名字', trigger: 'blur' }]
      }
    }
  },
  computed: {
    // 上传请求头：携带管理员token
    uploadHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem('adminToken') || ''}`
      }
    }
  },
  mounted() {
    this.fetchThemeList()
  },
  methods: {
    // 上传前校验图片类型和大小（与后端限制一致：JPG/PNG/GIF，5MB）
    beforeBgUpload(file) {
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']
      if (!allowedTypes.includes(file.type)) {
        this.$message.error('只支持JPG、PNG、GIF格式的图片')
        return false
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过5MB')
        return false
      }
      this.bgUploading = true
      return true
    },

    // 背景图上传成功：取返回的图片URL填入表单
    handleBgSuccess(res) {
      this.bgUploading = false
      if (res.code === 0 && res.data && res.data.url) {
        this.form.background_image = res.data.url
        this.$message.success('背景图上传成功')
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },

    // 背景图上传失败
    handleBgError() {
      this.bgUploading = false
      this.$message.error('上传失败，请检查网络后重试')
    },

    // 获取PK主题列表
    fetchThemeList() {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/content/pk-theme-list?page=${this.currentPage}&pageSize=${this.pageSize}&theme=${encodeURIComponent(this.searchForm.theme)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.themeList = data.data.list
          this.total = data.data.total
        } else {
          this.$message.error(data.message || '获取PK主题列表失败')
        }
      })
      .catch(() => {
        this.$message.error('获取PK主题列表失败')
      })
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.fetchThemeList()
    },

    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchThemeList()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchThemeList()
    },

    // 添加主题
    handleAdd() {
      this.dialogTitle = '添加主题'
      this.form = {
        id: null,
        theme: '',
        believe_name: '',
        disbelieve_name: '',
        background_image: '',
        status: 1,
        sort: 0
      }
      this.dialogVisible = true
    },

    // 编辑主题
    handleEdit(row) {
      this.dialogTitle = '编辑主题'
      this.form = {
        id: row.id,
        theme: row.theme,
        believe_name: row.believe_name,
        disbelieve_name: row.disbelieve_name,
        background_image: row.background_image || '',
        status: row.status,
        sort: row.sort
      }
      this.dialogVisible = true
    },

    // 关闭弹窗时清除校验
    resetForm() {
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate()
      }
    },

    // AI一键生成主题（DeepSeek），生成后自动填充表单
    async handleAiGenerate() {
      this.aiGenerating = true
      try {
        const token = localStorage.getItem('adminToken')
        const res = await fetch('/api/admin/content/generate-pk-theme', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        })
        const data = await res.json()
        if (data.code === 0 && data.data) {
          this.form.theme = data.data.theme || ''
          this.form.believe_name = data.data.believe_name || ''
          this.form.disbelieve_name = data.data.disbelieve_name || ''
          this.$message.success('AI生成成功，可手动调整后保存')
          // 填充后清除三个必填项的校验红字
          this.$nextTick(() => {
            if (this.$refs.formRef) {
              this.$refs.formRef.clearValidate(['theme', 'believe_name', 'disbelieve_name'])
            }
          })
        } else {
          this.$message.error(data.message || 'AI生成失败，请稍后重试')
        }
      } catch (e) {
        this.$message.error('AI生成失败，请检查网络或稍后重试')
      } finally {
        this.aiGenerating = false
      }
    },

    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        this.submitting = true
        const token = localStorage.getItem('adminToken')
        const url = this.form.id ? '/api/admin/content/update-pk-theme' : '/api/admin/content/create-pk-theme'
        // background_image 为图片URL字符串，空串=使用默认背景
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(this.form)
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success(this.form.id ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.fetchThemeList()
          } else {
            this.$message.error(data.message || '操作失败')
          }
        })
        .catch(() => {
          this.$message.error('操作失败')
        })
        .finally(() => {
          this.submitting = false
        })
      })
    },

    // 删除主题
    handleDelete(id) {
      this.$confirm('确定要删除该PK主题吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/content/delete-pk-theme', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchThemeList()
          } else {
            this.$message.error(data.message || '删除失败')
          }
        })
        .catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 切换启用状态
    handleStatusChange(row) {
      const newStatus = row.status === 1 ? 0 : 1
      const token = localStorage.getItem('adminToken')
      fetch('/api/admin/content/toggle-pk-theme-status', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id: row.id, status: newStatus })
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          row.status = newStatus
          this.$message.success(newStatus === 1 ? '已启用' : '已禁用')
        } else {
          this.$message.error(data.message || '操作失败')
        }
      })
      .catch(() => {
        this.$message.error('操作失败')
      })
    },

    // 格式化日期（时间戳为秒级）
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.love-pk-theme-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.form-tip {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}

/* 背景图列表缩略图（点击可预览大图） */
.bg-thumb {
  width: 60px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  cursor: pointer;
  display: block;
}
.bg-thumb--empty {
  color: #c0c4cc;
  font-size: 12px;
}

/* 弹窗内背景图上传 */
.bg-uploader {
  display: inline-block;
  vertical-align: top;
}
.bg-uploader__preview,
.bg-uploader__placeholder {
  width: 148px;
  height: 148px;
  border-radius: 6px;
}
.bg-uploader__preview {
  object-fit: cover;
  border: 1px solid #dcdfe6;
  display: block;
}
.bg-uploader__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px dashed #d9d9d9;
  background: #fbfdff;
  color: #8c939d;
  cursor: pointer;
  transition: border-color 0.2s;
}
.bg-uploader__placeholder:hover {
  border-color: #409eff;
  color: #409eff;
}
.bg-uploader__placeholder i {
  font-size: 28px;
}
.bg-uploader__placeholder span {
  font-size: 12px;
}
.bg-uploader__remove {
  margin-left: 10px;
}
.bg-uploader__tip {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.6;
  color: #909399;
}

/* AI生成按钮区：提示文字放在按钮下方 */
.ai-generate__tip {
  margin-top: 8px;
  font-size: 12px;
  line-height: 1.6;
  color: #909399;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
